import setConsentData from "./set_consent_data";
import checkState from "./check_state";
import setSwitchesData from "./set_switches_data";

const init = () => {

    // if cookie 
    // do the shit, execute the ads
    // else
    // wait for the user to do something ... what the actual fuck

    setConsentData();
    setSwitchesData();
    checkState();
}

export default init;